<div class="d-flex gap-3">
  <div class="container-box shadow-none flex-fill">
    <div class="d-flex gap-3 align-items-center p-3">
      <img src="/assets/images/channel-wizards/step-icon1.webp" alt="" height="40" />
      <div>
        <h6 class="mb-0" i18n>Preparation</h6>
        <div class="text-sm">
          <ng-container i18n>This section will prepare you for connecting Agoda with AdvanceCM.</ng-container> <br />
          <ng-container i18n>Please read through these instructions carefully before proceeding.</ng-container>
        </div>
      </div>
    </div>
    <div class="border-top p-4">
      <div>
        <mat-accordion>
          <mat-expansion-panel [expanded]="true" #start>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="step-number mr-2">1</div>
                <ng-container i18n>Create or Import Rentals</ng-container>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <div class="text-bold" i18n>Linking AdvanceCM to Agoda</div>
              <ul class="pl-3">
                <li i18n>Ensure you have a rental in AdvanceCM before linking to Agoda.</li>
                <li i18n>Create or import a rental in AdvanceCM if you haven't done so.</li>
              </ul>
              <div class="text-bold" i18n>Connecting Airbnb First</div>
              <ul class="pl-3">
                <li i18n>Connect Airbnb to AdvanceCM first for convenience.</li>
                <li i18n>This allows you to have rentals imported to AdvanceCM before linking with Agoda.</li>
              </ul>
              <div class="text-bold" i18n>Multiple Channel Connections</div>
              <ul class="pl-3">
                <li i18n>One AdvanceCM rental can connect to various channels.</li>
                <li i18n>Combined availability from all connected channels will sync automatically.</li>
              </ul>
              <p><ng-container i18n>For detailed steps, follow this</ng-container> <a href="" i18n>guide</a>.</p>
              <div class="text-right">
                <button class="btn btn-light-info" (click)="blockedDates.open()">
                  <ng-container i18n>Next</ng-container> <i class="cs-icon cs-icon-arrow-down-long"></i>
                </button>
              </div>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel #blockedDates>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="step-number mr-2">2</div>
                <ng-container i18n>Blocked Dates</ng-container>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <div class="text-bold" i18n>Availability Management</div>
              <ul class="pl-3">
                <li i18n>Your AdvanceCM rental calendar will solely determine availability.</li>
                <li i18n>Blocked or closed dates on Agoda will be reopened, except for confirmed bookings.</li>
              </ul>
              <div class="text-bold" i18n>Maintaining Blocked Dates</div>
              <ul class="pl-3">
                <li i18n>Add hold events to your AdvanceCM calendar to keep dates blocked.</li>
                <li i18n>Do this before or after completing the connection steps.</li>
              </ul>
              <p><ng-container i18n>For detailed steps, follow this</ng-container> <a href="" i18n>guide</a>.</p>
              <div class="text-right">
                <button class="btn btn-light-info" (click)="prepareRates.open()">
                  <ng-container i18n>Next</ng-container> <i class="cs-icon cs-icon-arrow-down-long"></i>
                </button>
              </div>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel #prepareRates>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="step-number mr-2">3</div>
                <ng-container i18n>Preparing Rates</ng-container>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <div class="text-bold" i18n>Rates and Availability Disabled</div>
              <ul class="pl-3">
                <li i18n>
                  After establishing the connection, rates and availability will be disabled until the wizard steps are
                  complete.
                </li>
                <li i18n>Push rates from AdvanceCM to Agoda; you cannot edit them directly on Agoda.</li>
              </ul>
              <div class="text-bold" i18n>Review Previous Rates</div>
              <ul class="pl-3">
                <li i18n>Review previous rates on the Booking.com calendar before proceeding.</li>
                <li i18n>Once connected, previous Agoda rates will not be visible.</li>
              </ul>
              <div class="text-bold" i18n>Preparing Rates</div>
              <ul class="pl-3">
                <li i18n>Pushing rates to Agoda is required in the wizard.</li>
                <li i18n>Use this guide to prepare rates before beginning.</li>
                <li i18n>
                  You can create or adjust rates within the wizard, but preparing a full rate plan in advance is
                  recommended.
                </li>
              </ul>
              <div class="text-bold" i18n>Rategenie Recommendation</div>
              <ul class="pl-3">
                <li i18n>Use Rategenie for advanced dynamic pricing.</li>
              </ul>
              <div class="alert alert-secondary-warning2 align-items-start">
                <i class="cs-icon cs-icon-alert-triangle2 alert-icon"></i>
                <div class="alert-content">
                  <b i18n>Note:</b>
                  <ng-container i18n
                    >Ensure your rates and availability are set up correctly in AdvanceCM to streamline the connection
                    process with Agoda.</ng-container
                  >
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      <div class="mt-5 d-flex align-items-center justify-content-between">
        <button class="btn btn-outline-light" (click)="prev.emit()">
          <i class="cs-icon cs-icon-arrow-left-long text-xxs"></i>
          <ng-container i18n>Previous</ng-container>
        </button>
        <button class="btn btn-secondary-info" (click)="next.emit()">
          <ng-container i18n>Next</ng-container>
          <i class="cs-icon cs-icon-arrow-right-long text-xxs"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="channel-wizard-right-wrapper rounded px-4">
    <img src="/assets/images/channel-wizards/step2.webp" alt="" class="w-100" />
  </div>
</div>
